import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { JSONTabularData } from './table/tabular-data.interface';

export interface IDataSource {
  http: HttpClient;
  headers: any;
  get(): Observable<Array<JSONTabularData>>;
}

export function factoryDummyData(cls: IDataSource) {
  return function() {
    const endpoint = 'assets/shared/fallback.json';
    return cls.http.get<Array<JSONTabularData>>(endpoint, cls.headers)
      .pipe(catchError(err => {
        console.warn('error connecting to endpoint', endpoint, err);
        return of([]);
      }));
  };
}
